var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { getBlockFormats, formatBlockElements } from '@progress/kendo-editor-common';
import { userSelectNone } from './utils';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages } from '../messages/main';
/**
 * @hidden
 */
var FormatBlockVue2 = {
  name: 'KendoFormatBlock',
  props: __assign({
    view: Object,
    settings: {
      type: Object,
      default: function _default() {
        return {
          messages: {}
        };
      }
    }
  }, DropDownList.props),
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      view = _a.view,
      render = _a.render,
      dataItems = _a.dataItems,
      settings = _a.settings,
      defaultItemProps = _a.defaultItem,
      other = __rest(_a, ["view", "render", "dataItems", "settings", "defaultItem"]);
    var items = dataItems || settings.items;
    var state = view && view.state;
    var formats = state ? getBlockFormats(state) : [];
    var value = new Set(formats).size === 1 ? formats[0] : null;
    var defaultItem = defaultItemProps || settings.defaultItem;
    var localization = provideLocalizationService(this);
    if (defaultItem && defaultItem.localizationKey) {
      defaultItem = __assign({}, defaultItem);
      defaultItem.text = defaultItem.localizationKey ? localization.toLanguageString(defaultItem.localizationKey, messages[defaultItem.localizationKey]) : defaultItem.text;
    }
    var ddlProps = __assign(__assign(__assign({}, other), {
      value: value ? items.find(function (i) {
        return i.value === value;
      }) : value,
      dataItems: items,
      defaultItem: defaultItem,
      itemRender: this.customItemRender,
      textField: 'text',
      dataItemKey: 'value',
      leftRightKeysNavigation: false,
      popupSettings: {
        width: '170px'
      },
      title: defaultItem.text
    }), settings.props);
    var dropdown = h(DropDownList, __assign({
      onChange: this.onChange,
      on: this.v3 ? undefined : {
        'change': this.onChange
      },
      style: userSelectNone,
      attrs: this.v3 ? undefined : ddlProps
    }, ddlProps));
    return dropdown;
  },
  methods: {
    customItemRender: function customItemRender(h, li, itemProps) {
      return itemProps.dataItem.style ? h('li', {
        class: itemProps.itemClass,
        onClick: itemProps.onClick,
        on: {
          click: itemProps.onClick
        }
      }, [h('span', {
        style: itemProps.dataItem.style
      }, __spreadArray([], li.children, true))]) : li;
    },
    onChange: function onChange(e) {
      var _a = this.$props,
        view = _a.view,
        settings = _a.settings;
      var item = e.target.value;
      if (view && formatBlockElements(item.value, settings.commandName)(view.state, view.dispatch)) {
        var event_1 = e.event;
        if (event_1 && event_1.type === 'click') {
          view.focus();
        }
      }
    }
  }
};
/**
 * @hidden
 */
var FormatBlock = FormatBlockVue2;
export { FormatBlock, FormatBlockVue2 };